import React, { useState, useCallback, useEffect } from "react";
import SpaceCategoriesCard from "./LeftPanel/SpaceCategoriesCard";
import SpaceTypesCard from "./LeftPanel/SpaceTypesCard";
// import RulesTable from "./RightPanel/RulesTable";
// import SpaceAlertsTable from "./RightPanel/SpaceAlertsTable";
import SpacePermissionsTable from "./RightPanel/SpacePermissionsTable";
import SpaceUsersTable from "./RightPanel/SpaceUsersTable";
import { useToast } from "components/Toaster/index";
import { ExternalShare } from "@induz/sdk";
import "./Spaces.scss";

const Spaces = ({ compress }) => {
  const [spaceCategories, setSpaceCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSpaceType, setSelectedSpaceType] = useState(null);
  const [spaceTypesByCategory, setSpaceTypesByCategory] = useState({});
  const [spaceUsers,setSpaceUsers]=useState([]);
    const formUserObj=(email)=>{

      //  this obj will be used in spaceUsersTable too
    return {
      user_email:email
    };
  };
  //  As of now i will be using spacetypesbycategory to store the object of selected space
  const [loading, setLoading] = useState(false);
  const showToast = useToast();

  // Load initial data from backend
  useEffect(() => {
    loadSpaceCategories();
  }, []);
  useEffect(() => {
    // console.log("space categories changed ", spaceCategories);
    const converted=convertSpaceCategoriesToTypes(spaceCategories);
    // console.log("converted space categories to types in useeffect ", converted);
    setSpaceTypesByCategory( converted);
    // console.log("spacetypesbycategory set to in useeffect ", spaceTypesByCategory);
    if (selectedCategory) {
      // console.log("selected category changed to ", selectedCategory, " loading space types");
      //  iterate through spacecategories and see which one matches the selectedcategory and set space users accordingly
      const category = spaceCategories.find(cat => cat.name === selectedCategory);
      if (category) {
        // console.log("setting space users to ", category.emails);
        setSpaceUsers((category.emails || []).map(email => formUserObj(email)));
      } else {
        // Clear space users if the selected category no longer exists (e.g., after deletion)
        setSpaceUsers([]);
      }
    } else {
      // Clear space users when no category is selected
      setSpaceUsers([]);
    }
  }, [spaceCategories,selectedCategory]);
  // useEffect(() => {
    
  // }, [selectedCategory]);
  // Backend API methods - TODO: Replace with actual backend calls
  const loadSpaceCategories = async () => {
    try {
      setLoading(true);
      // TODO: Replace with actual backend API call
      // const response = await fetchSpaceCategories();
      // setSpaceCategories(response.data);
      // console.log("about to call list spaces");
      const response = await ExternalShare.listSpacesOfUser();
      // console.log("response from list spaces is ", response);

      // Placeholder data for now
      // const mockSpaceCategories = [
      //   { name: "Space 1", enabled: true },
      //   { name: "Space 2", enabled: true },
      //   { name: "Space 3", enabled: true }
      // ];
      const mockSpaceCategories = response.map(space => {
        console.log("space in listSpacesOfUser response ", space);
        return ({
        name: space.getName(),
        emails: space.getUserEmails(),
        creationTime: space.getCreationTime(), 
        updatedTime: space.getUpdatedTime(),
        operations: space.getOperationsStrings(),
        allowedCountries: space.getAllowedLocations() || space.spaceObjInResponse?.allowedCountries || [],
        deniedCountries: space.getDeniedLocations() || space.spaceObjInResponse?.deniedCountries || [],
        allowedRegions: space.getAllowedRegions() || space.spaceObjInResponse?.allowedRegions || [],
        deniedRegions: space.getDeniedRegions() || space.spaceObjInResponse?.deniedRegions || [],
        allowedIps: space.getAllowedIps() || [],
        deniedIps: space.getDeniedIps() || [],
        allowedFileTypes: space.getAllowedFileTypes() || [],
        deniedFileTypes: space.getDeniedFileTypes() || [],
        maxFileSize: space.getMaxFileSize() || null,
        maxSpaceSize: space.getMaxSpaceSize() || null,
        objectsInfo: space.getInfoOfSharedObjs()?.map(obj => ({
          uuid: obj.getUuid(),
          name: obj.getName(),
          isFolder:obj.isFolder(),
        })) || [],
        enabled: true
      });
      });
      // console.log("mockspace objects ", mockSpaceCategories);
      setSpaceCategories(mockSpaceCategories);
      if (mockSpaceCategories.length > 0) {
        // Only set selected category to first space if no category is currently selected
        // or if the currently selected category no longer exists in the list
        setSelectedCategory((prevSelected) => {
          if (!prevSelected || !mockSpaceCategories.some(cat => cat.name === prevSelected)) {
            // If no category is selected or the selected category doesn't exist, select the first one
            return mockSpaceCategories[0].name;
          }
          // Preserve the currently selected category
          return prevSelected;
        });
        // console.log("loading space types for ", mockSpaceCategories[0].name);
        //  also print the selected category to console
        // console.log("selected category is ", selectedCategory);
        // loadSpaceTypes(mockSpaceCategories[0].name);
        // const converted=convertSpaceCategoriesToTypes(mockSpaceCategories);
        // console.log("converted space categories to types ", converted);
        // setSpaceTypesByCategory( converted);
        // console.log("spacetypesbycategory set to ", spaceTypesByCategory);
      }
    } catch (error) {
      showToast("Failed to load space categories", "error");
      console.error("Error loading space categories:", error);
    } finally {
      setLoading(false);
    }
  };
  //  write a helper to convert space categories to space types by category
  const convertSpaceCategoriesToTypes = (categories = []) => {
          const spaceTypesByCategories = categories.reduce((acc, space) => {
            // console.log("space in convert function ", space);
              const objs = space.objectsInfo||[];
              acc[space.name] = objs.map(obj => ({
                name: obj.name,
                uuid: obj.uuid,
                isFolder: obj.isFolder || false,
                enabled: true
              }));
              return acc;
            }, {});
            // console.log("converted space types by categories ", spaceTypesByCategories);
            return spaceTypesByCategories;
  };
  const loadSpaceTypes = async (categoryName) => {
    try {
      // TODO: Replace with actual backend API call
      // const response = await fetchSpaceTypes(categoryName);
      // setSpaceTypesByCategory(prev => ({
      //   ...prev,
      //   [categoryName]: response.data
      // }));

      //  iterate through spaceCategories and see the corresponding object that mactches the name and set spacetypesbycategory accordingly
      //        const mockSpaceCategories=response.map(space=>({
      //   name:space.name,
      //   creationTime: space.creationTime,
      //   updatedTime: space.updatedTime,
      //   operations:space.operations,
      //   objectsInfo:{
      //     uuid:space.infoOfSharedObjs.uuid,
      //     name:space.infoOfSharedObjs.name,
      //   },
      //   enabled:true
      // }));
      // console.log("space categories in load space types ", spaceCategories," and category name is ", categoryName);
          const spaceTypesByCategories = spaceCategories.reduce((acc, space) => {
              const objs = space.objectsInfo
                ? (Array.isArray(space.objectsInfo) ? space.objectsInfo : [space.objectsInfo])
                : [];
              acc[space.name] = objs.map(obj => ({
                name: obj.name,
                uuid: obj.uuid,
                enabled: true,
                isFolder: obj.isFolder || false,
              }));
              return acc;
            }, {});

            // console.log("setting spacetypesbycategory to ", spaceTypesByCategories);
      setSpaceTypesByCategory(spaceTypesByCategories);
    } catch (error) {
      showToast("Failed to load space types", "error");
      console.error("Error loading space types:", error);
    }
  };

  // Space Categories handlers
  const handleSelectCategory = useCallback(async (name) => {
    // Prevent reloading if the same space is already selected
    if (selectedCategory === name) {
      return;
    }
    setSelectedCategory(name);
    setSelectedSpaceType(null); // Reset space type selection when category changes
    await loadSpaceTypes(name);
  }, [selectedCategory]);

  const handleAddCategory = useCallback(async (name) => {
    const trimmed = (name || "").trim();
    if (!trimmed) return false;
    // Validate space name length (max 80 characters)
    if (trimmed.length > 80) {
      showToast("Space name cannot exceed 80 characters", "error");
      return false;
    }
    // Validate space name with regex: allow only alphanumeric and '.', '-', '_', '@', ','
    const spaceNameRegex = /^[a-zA-Z0-9.\-_@,]+$/;
    if (!spaceNameRegex.test(trimmed)) {
      showToast("Space name can only contain alphanumeric characters and '.', '-', '_', '@', ','", "error");
      return false;
    }
    const exists = spaceCategories.some((cat) => cat.name.toLowerCase() === trimmed.toLowerCase());
    if (exists) {
      showToast("A space with this name already exists. Please choose a different name.", "error");
      return false;
    }

    try {
      // TODO: Replace with actual backend API call
      const space = await ExternalShare.addSpace([], trimmed);
      const newObj = {
        name: space.getName(),
        creationTime: space.getCreationTime(),
        updatedTime: space.getUpdatedTime(),
        operations: space.getOperationsStrings(),
        allowedCountries: space.getAllowedLocations() || space.spaceObjInResponse?.allowedCountries || [],
        deniedCountries: space.getDeniedLocations() || space.spaceObjInResponse?.deniedCountries || [],
        allowedRegions: space.getAllowedRegions() || space.spaceObjInResponse?.allowedRegions || [],
        deniedRegions: space.getDeniedRegions() || space.spaceObjInResponse?.deniedRegions || [],
        allowedIps: space.getAllowedIps() || [],
        deniedIps: space.getDeniedIps() || [],
        allowedFileTypes: space.getAllowedFileTypes() || [],
        deniedFileTypes: space.getDeniedFileTypes() || [],
        maxFileSize: space.getMaxFileSize() || null,
        maxSpaceSize: space.getMaxSpaceSize() || null,
        objectsInfo: space.getInfoOfSharedObjs()?.map(obj => ({
          uuid: obj.getUuid(),
          name: obj.getName()
        })) || [],
        enabled: true
      };
      // console.log("response from add space is ", space);
      if (space) {
        setSpaceCategories((prev) => [...prev, newObj]);
        setSelectedCategory(trimmed);
        setSpaceTypesByCategory((prev) => ({
          ...prev,
          [trimmed]: []
        }));
        showToast("Space created successfully", "success");
        return true;
      }

      // Placeholder implementation
      setSpaceCategories((prev) => [...prev, { name: trimmed, enabled: true }]);
      setSelectedCategory(trimmed);
      setSpaceTypesByCategory((prev) => ({
        ...prev,
        [trimmed]: []
      }));
      showToast("Space created successfully", "success");
      return true;
    } catch (error) {
      showToast("Failed to create space category", "error");
      console.error("Error creating space category:", error);
      return false;
    }
  }, [spaceCategories, showToast]);

  const handleUpdatePermissionsOfcategory = async (
    name,
    newPermissions,
    allowedIps = [],
    deniedIps = [],
    allowedCountries = [],
    deniedCountries = [],
    allowedRegions = [],
    deniedRegions = [],
    allowedFileTypes = [],
    deniedFileTypes = [],
    maxSpaceSize,
    maxFileSize
  ) => {
       console.log("Calling ExternalShare.updateSpaceOperations with:", {
         name,
         operations: newPermissions,
         allowedIps,
         deniedIps,
         allowedCountries,
         deniedCountries,
         allowedRegions,
         deniedRegions,
         allowedFileTypes,
         deniedFileTypes,
         maxSpaceSize,
         maxFileSize
       });
       await ExternalShare.updateSpaceOperations(
         newPermissions,
         name,
         allowedIps,
         deniedIps,
         allowedCountries,
         deniedCountries,
         allowedRegions,
         deniedRegions,
         allowedFileTypes,
         deniedFileTypes,
         maxSpaceSize,
         maxFileSize
       );
       console.log("ExternalShare.updateSpaceOperations success for space:", name);
       // Update local state immediately so saved values remain visible in UI.
       setSpaceCategories((prev) =>
         prev.map((space) =>
           space.name === name
             ? {
                 ...space,
                 operations: [...newPermissions],
                 allowedIps: [...allowedIps],
                 deniedIps: [...deniedIps],
                 allowedCountries: [...allowedCountries],
                 deniedCountries: [...deniedCountries],
                 allowedRegions: [...allowedRegions],
                 deniedRegions: [...deniedRegions],
                 allowedFileTypes: [...allowedFileTypes],
                 deniedFileTypes: [...deniedFileTypes],
                 maxSpaceSize: maxSpaceSize ?? null,
                 maxFileSize: maxFileSize ?? null
               }
             : space
         )
       );
  };

  const handleSetCategoryEnabled = useCallback(async (name, enabled) => {
    try {
      // TODO: Replace with actual backend API call
      // const response = await updateSpaceCategory(name, { enabled });
      // if (response.success) {
      //   setSpaceCategories((prev) =>
      //     prev.map((cat) => (cat.name === name ? { ...cat, enabled } : cat))
      //   );
      //   showToast(`Space category ${enabled ? 'enabled' : 'disabled'} successfully`, "success");
      // }

      // Placeholder implementation
      setSpaceCategories((prev) =>
        prev.map((cat) => (cat.name === name ? { ...cat, enabled } : cat))
      );
      showToast(`Space category ${enabled ? "enabled" : "disabled"} successfully`, "success");
    } catch (error) {
      showToast("Failed to update space category", "error");
      console.error("Error updating space category:", error);
    }
  }, [showToast]);

  const handleDeleteCategory = useCallback(async (name) => {
    try {
      // TODO: Replace with actual backend API call
      // console.log("calling remove space");
      await ExternalShare.RemoveSpace(name);
      // console.log("called remove space");
      // if (response.success) {
      //   setSpaceCategories((prev) => prev.filter((cat) => cat.name !== name));
      //   
      //   // If the deleted category was selected, select the first available one
      //   if (selectedCategory === name) {
      //     const remainingCategories = spaceCategories.filter((cat) => cat.name !== name);
      //     if (remainingCategories.length > 0) {
      //       setSelectedCategory(remainingCategories[0].name);
      //     } else {
      //       setSelectedCategory(null);
      //     }
      //   }
      //   
      //   // Remove space types for the deleted category
      //   setSpaceTypesByCategory((prev) => {
      //     const newSpaceTypes = { ...prev };
      //     delete newSpaceTypes[name];
      //     return newSpaceTypes;
      //   });
      //   showToast("Space category deleted successfully", "success");
      // }

      // Placeholder implementation
      setSpaceCategories((prev) => prev.filter((cat) => cat.name !== name));

      // If the deleted category was selected, select the first available one
      if (selectedCategory === name) {
        const remainingCategories = spaceCategories.filter((cat) => cat.name !== name);
        if (remainingCategories.length > 0) {
          setSelectedCategory(remainingCategories[0].name);
        } else {
          setSelectedCategory(null);
        }
      }

      // Remove space types for the deleted category
      setSpaceTypesByCategory((prev) => {
        const newSpaceTypes = { ...prev };
        delete newSpaceTypes[name];
        return newSpaceTypes;
      });
      showToast("Space deleted successfully", "success");
    } catch (error) {
      showToast("Failed to delete space category", "error");
      console.error("Error deleting space category:", error);
    }
  }, [spaceCategories, selectedCategory, showToast]);

  // Space Types handlers
  const handleSelectSpaceType = useCallback((name) => {
    setSelectedSpaceType(name);
  }, []);

  const handleAddSpaceType = useCallback(async (name) => {
    const trimmed = (name || "").trim();
    if (!trimmed) return false;

    const currentSpaceTypes = spaceTypesByCategory[selectedCategory] || [];
    const exists = currentSpaceTypes.some((type) => type.name.toLowerCase() === trimmed.toLowerCase());
    if (exists) return false;

    try {
      // TODO: Replace with actual backend API call
      // const response = await createSpaceType(selectedCategory, { name: trimmed, enabled: true });
      // if (response.success) {
      //   setSpaceTypesByCategory((prev) => ({
      //     ...prev,
      //     [selectedCategory]: [...(prev[selectedCategory] || []), response.data]
      //   }));
      //   setSelectedSpaceType(trimmed);
      //   showToast("Space type created successfully", "success");
      //   return true;
      // }

      // Placeholder implementation
      setSpaceTypesByCategory((prev) => ({
        ...prev,
        [selectedCategory]: [...(prev[selectedCategory] || []), { name: trimmed, enabled: true }]
      }));
      setSelectedSpaceType(trimmed);
      showToast("Space type created successfully", "success");
      return true;
    } catch (error) {
      showToast("Failed to create space type", "error");
      console.error("Error creating space type:", error);
      return false;
    }
  }, [selectedCategory, spaceTypesByCategory, showToast]);

  const handleSetSpaceTypeEnabled = useCallback(async (name, enabled) => {
    try {
      // TODO: Replace with actual backend API call
      // const response = await updateSpaceType(selectedCategory, name, { enabled });
      // if (response.success) {
      //   setSpaceTypesByCategory((prev) => ({
      //     ...prev,
      //     [selectedCategory]: prev[selectedCategory].map((type) =>
      //       type.name === name ? { ...type, enabled } : type)
      //   }));
      //   showToast(`Space type ${enabled ? 'enabled' : 'disabled'} successfully`, "success");
      // }

      // Placeholder implementation
      setSpaceTypesByCategory((prev) => ({
        ...prev,
        [selectedCategory]: prev[selectedCategory].map((type) =>
          type.name === name ? { ...type, enabled } : type)
      }));
      showToast(`Space type ${enabled ? "enabled" : "disabled"} successfully`, "success");
    } catch (error) {
      showToast("Failed to update space type", "error");
      console.error("Error updating space type:", error);
    }
  }, [selectedCategory, showToast]);

  const handleDeleteSpaceType = useCallback(async (uuid) => {
    try {
      // Find the item being deleted to get its name for comparison
      const currentSpaceTypes = spaceTypesByCategory[selectedCategory] || [];
      const itemToDelete = currentSpaceTypes.find((type) => type.uuid === uuid);
      const deletedItemName = itemToDelete?.name;
      
      // Call backend API to remove object from space
      await ExternalShare.removeObjectFromSpace(uuid, selectedCategory);
      
      // Update spaceCategories to remove the deleted object from objectsInfo
      // This ensures data consistency since spaceTypesByCategory is derived from spaceCategories
      setSpaceCategories((prev) =>
        prev.map((category) =>
          category.name === selectedCategory
            ? {
                ...category,
                objectsInfo: (category.objectsInfo || []).filter((obj) => obj.uuid !== uuid)
              }
            : category
        )
      );

      // If the deleted space type was selected, clear the selection
      // selectedSpaceType stores the name, not uuid
      if (selectedSpaceType === deletedItemName) {
        setSelectedSpaceType(null);
      }
      
      showToast("Space folder deleted successfully", "success");
    } catch (error) {
      showToast("Failed to delete space type", "error");
      console.error("Error deleting space type:", error);
    }
  }, [selectedCategory, selectedSpaceType, spaceTypesByCategory, showToast]);

  // Right panel state
  const [activeTab, setActiveTab] = useState("permissions");

  // Alerts state for SpaceAlertsTable
  // const [alertsSearchQuery, setAlertsSearchQuery] = useState("");

  // Permissions state for SpacePermissionsTable
  const [permissionsSearchQuery, setPermissionsSearchQuery] = useState("");

  // Users state for SpaceUsersTable
  const [usersSearchQuery, setUsersSearchQuery] = useState("");

  // const handleAlertsSearch = (query) => {
  //   setAlertsSearchQuery(query);
  // };

  const handlePermissionsSearch = (query) => {
    setPermissionsSearchQuery(query);
  };

  const handleUsersSearch = (query) => {
    setUsersSearchQuery(query);
  };

  // const handleAddAlert = useCallback(async (newAlert) => {
  //   try {
  //     // TODO: Replace with actual backend API call
  //     // const response = await createSpaceAlert({
  //     //   category: selectedCategory,
  //     //   spaceType: selectedSpaceType,
  //     //   ...newAlert
  //     // });
  //     // if (response.success) {
  //     //   showToast("Space alert created successfully", "success");
  //     //   // Optionally refresh alerts data
  //     //   // await loadSpaceAlerts(selectedCategory, selectedSpaceType);
  //     // }

  //     // Placeholder implementation
  //     console.log("New space alert added:", newAlert);
  //     showToast("Space alert created successfully", "success");
  //   } catch (error) {
  //     showToast("Failed to create space alert", "error");
  //     console.error("Error creating space alert:", error);
  //   }
  // }, [selectedCategory, selectedSpaceType, showToast]);

  if (loading) {
    return (
      <section className={`SpacesPage ${compress ? "compressed" : ""}`}>
        <div className="SpacesGrid">
          <div style={{ padding: "20px", textAlign: "center", opacity: 0.7, color: "var(--text-grey-strong)" }}>
            Loading spaces data...
          </div>
        </div>
      </section>
    );
  }

  // console.log("rendering spaces with spaceCategories ", spaceCategories, " selectedCategory ", selectedCategory, " spaceTypesByCategory ", spaceTypesByCategory);

  return (
    <section className={`SpacesPage ${compress ? "compressed" : ""}`}>
      <div className="SpacesGrid">
        <div className="SpacesCol">
          <SpaceCategoriesCard
            categories={spaceCategories}
            selectedCategory={selectedCategory}
            onSelectCategory={handleSelectCategory}
            onAddCategory={handleAddCategory}
            onSetCategoryEnabled={handleSetCategoryEnabled}
            onDeleteCategory={handleDeleteCategory}
          />
          <SpaceTypesCard
            spaceObjs={spaceTypesByCategory[selectedCategory] || []}
            selectedCategory={selectedCategory}
            selectedSpaceType={selectedSpaceType}
            onSelectSpaceType={handleSelectSpaceType}
            onAddSpaceType={handleAddSpaceType}
            onSetSpaceTypeEnabled={handleSetSpaceTypeEnabled}
            onDeleteSpaceType={handleDeleteSpaceType}
          />
        </div>
        <div className="SpacesCol">
          <div className="formTabs">
            <div className="tabsBox">
              {/* <p
                onClick={() => setActiveTab("alerts")}
                className={activeTab === "alerts" ? "active" : ""}
              >
                Alerts
                <span className="tabIndicator" />
              </p> */}
              {/* <p
                onClick={() => setActiveTab("rules")}
                className={activeTab === "rules" ? "active" : ""}
              >
                Rules
                <span className="tabIndicator" />
              </p> */}

              <p
                onClick={() => setActiveTab("permissions")}
                className={activeTab === "permissions" ? "active" : ""}

              >
                Permissions
                <span className="tabIndicator"></span>

              </p>

              <p onClick={() => setActiveTab("users")}
                className={activeTab === "users" ? "active" : ""}
              >

                Users

                <span className="tabIndicator"></span>

              </p>
            </div>
          </div>

          {/* Alerts Table */}
          {/* {activeTab === "alerts" && (
            <SpaceAlertsTable
              category={selectedCategory}
              spaceType={selectedSpaceType}
              searchQuery={alertsSearchQuery}
              onSearch={handleAlertsSearch}
              onAddAlert={handleAddAlert}
            />
          )} */}

          {/* Permissions Table */}
          {activeTab === "permissions" && (
            <SpacePermissionsTable
              key={selectedCategory || "no-space"}
              searchQuery={permissionsSearchQuery}
              onSearch={handlePermissionsSearch}
              spaceOps={spaceCategories.find(cat => cat.name === selectedCategory)?.operations || []}
              spaceConfig={spaceCategories.find(cat => cat.name === selectedCategory) || null}
              spaceName={selectedCategory}
              handleUpdateSpacePermissions={handleUpdatePermissionsOfcategory}
            />
          )}

          {/* Users Table */}
          {activeTab === "users" && (
            <SpaceUsersTable
              searchQuery={usersSearchQuery}
              onSearch={handleUsersSearch}
              spaceUsers={spaceUsers||[]}
              setSpaceUsers={setSpaceUsers}
              selectedCategory={selectedCategory}
              formUserObj={formUserObj}
              onUserAdded={async () => {
                // Refresh space categories after user is added to get updated user list
                await loadSpaceCategories();
              }}
              onUserRemoved={async () => {
                // Refresh space categories after user is removed to get updated user list
                await loadSpaceCategories();
              }}
            />
          )}

          {/* Rules Table
          {activeTab === "rules" && (
            <RulesTable />
          )} */}
        </div>
      </div>


    </section>
  );
};

export default Spaces;
